module.exports = __webpack_public_path__ + "files/9f22f4ef21101023eb61b0156ebfa7d2.png";